<template>
  <div>
    <Toast></Toast>
    <ConfirmDialog></ConfirmDialog>
    <Dialog
      v-model:visible="showThisModel"
      style="width: 70%; max-height: 90%"
      @hide="closeModal()"
      :modal="true"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">Resources</h4>
      </template>

      <div class="modal-content">
        <div class="modal-body mb-1 pt-2">
            <ResourceComponent
                :p_visitId="p_visitId"
              ></ResourceComponent>
        </div>

      </div>
    </Dialog>
  </div>
</template>

<script>
import ResourceComponent from "../VeinsTracker/ResourceComponent/ResourceComponent.vue";

export default {
  name: "ResourceComponentPopup",
  mixins: [],
  components: {ResourceComponent},
  props: {
    p_visitId: Number,
  },

  data() {
    return {
      showThisModel: false,
    };
  }, // data

  methods: {
      closeModal() {
      this.showThisModel = false;
      this.$emit('close-modal', false);
    },
  },

  mounted() {
    this.showThisModel = true;
  },
};
</script>

<style lang="scss" scoped>
::v-deep(.p-paginator) {
  .p-paginator-current {
    margin-left: auto;
  }
}
::v-deep(.p-progressbar) {
  height: 0.5rem;
  background-color: #d8dadc;
  .p-progressbar-value {
    background-color: #607d8b;
  }
}
::v-deep(.p-datepicker) {
  min-width: 25rem;
  td {
    font-weight: 400;
  }
}
::v-deep(.p-datatable.p-datatable-customers) {
  .p-datatable-header {
    padding: 1rem;
    text-align: center;
    font-size: 1.5rem;
  }
  .p-paginator {
    padding: 1rem;
  }
  .p-paginator .p-paginator-pages .p-paginator-page {
    background-color: transparent;
    border: 1px;
    border-color: dimgray;
    color: #495057;
    min-width: 2.357rem;
    height: 2.357rem;
    margin: 0.143rem;
    box-shadow: none;
    border-radius: 0px;
  }
  .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
    background: darkorange;
    border: 1px;
    // border-color: darkorange;
    color: white;
  }
  .p-datatable-thead > tr > th {
    text-align: center;
    background-color: #000000;
    color: white;
    font-weight: 700;
  }
  .p-datatable-tbody > tr > td {
    cursor: auto;
  }
  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}
</style>